<template>
	<div :class="`help-tooltip ${classBinding}`">
		<slot />
	</div>
</template>

<script>
export default {
	name: "ResolutionTooltip",
	props: {
		specific: {
			type: Boolean,
			default: false
		},
		classBinding: {
			type: String,
			default: ""
		}
	}
};
</script>

<style lang="scss" scoped>

.help-tooltip {
	transform: translate(-97%, -105%);
	opacity: 0.98;
	border-radius: 2px;
	background-color: #252525;
	min-width: 300px;
	position: absolute;
	color: #FFF;

	@media (hover: none) {
		display: none;
	}
}

.fps-tooltip,
.fps-tooltip-prebuilds,
.fps-tooltip-starter-series {
	padding: 15px;
	font-size: 16px;
}

.fps-tooltip {
	background: #949494;
}

.fps-tooltip-prebuilds {
	background-color: #111111;
}

.fps-tooltip-starter-series {
	background-color: #252525;
}
</style>